module.exports = __webpack_public_path__ + "static/img/beian.c2341a36.png";